import React from 'react';
import GenericPrivacyPolicyPage from '../components/GenericPrivacyPolicyPage'; // Adjusted path

const LAST_UPDATED_DATE = 'May 2025'; // Updated date

const WEBSITE_PRIVACY_POLICY_CONTENT = `
This Privacy Policy applies to the CodeMates website (codemates.app) and services.

1. Information We Collect
When you visit our website, we may collect non-personally identifiable information such as your browser type, operating system, and pages visited to help us improve our website and services. If you contact us via email, we will collect your email address and any information you provide in your message.

2. Use of Information
We use the information collected to:
- Respond to your inquiries and provide support.
- Improve our website, applications, and services.
- Send periodic emails if you have opted-in to receive them (you can unsubscribe at any time).

3. Information Sharing
We do not sell, trade, or otherwise transfer to outside parties your personally identifiable information unless we provide users with advance notice. This does not include website hosting partners and other parties who assist us in operating our website, conducting our business, or serving our users, so long as those parties agree to keep this information confidential. We may also release information when it's release is appropriate to comply with the law, enforce our site policies, or protect ours or others' rights, property or safety.

4. Cookies
Our website may use "cookies" to enhance user experience. Your web browser places cookies on your hard drive for record-keeping purposes and sometimes to track information about you. You may choose to set your web browser to refuse cookies, or to alert you when cookies are being sent. If they do so, note that some parts of the Site may not function properly.

5. Third-Party Links
Occasionally, at our discretion, we may include or offer third-party products or services on our website. These third-party sites have separate and independent privacy policies. We therefore have no responsibility or liability for the content and activities of these linked sites.

6. Security
We implement a variety of security measures to maintain the safety of your personal information when you submit or access your personal information.

7. Changes to This Privacy Policy
We reserve the right to update or change our Privacy Policy at any time. We will post any changes on this page with an updated "Last Updated" date. You are advised to review this Privacy Policy periodically for any changes.

8. Contact Us
If you have any questions about this Privacy Policy, please contact us at <a href="mailto:support@codemates.app" style="color:#007bff;text-decoration:none;">support@codemates.app</a>.
`;

function WebsitePrivacyPolicyPage() {
  return (
    <GenericPrivacyPolicyPage
      appName="CodeMates Website" // Or simply null/empty if no prefix desired
      lastUpdatedDate={LAST_UPDATED_DATE}
      policyContent={WEBSITE_PRIVACY_POLICY_CONTENT}
    />
  );
}

export default WebsitePrivacyPolicyPage; 